module.exports = __webpack_public_path__ + "6a8b456af5033830a5dfea01f5562e31.svg";